<template>
<div>
  <vs-list-header icon="signal_cellular_alt" title="Overview Sensor" style="font-size: 18px;" color="#147efb"></vs-list-header>
    <vs-table hoverFlat="false" max-items="3" pagination stripe :data="lastsensor">
      
      <template slot="thead">
        <vs-th style="padding: 0px">
          Sensor Name
        </vs-th>
        <vs-th style="padding: 0px">
          Sensor Type
        </vs-th>
        <vs-th style="padding: 0px">
          Reading Data
        </vs-th>
        <vs-th style="padding: 0px">
          Battery
        </vs-th>
        <vs-th style="padding: 0px">
          Timestamp
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td>
            
            {{data[indextr].name}}
          </vs-td>
          <vs-td>
             <span v-if="data[indextr].type=='Temp&Humid'" class="font-weight-normal badge badge-info badge-pill px-2 py-1">{{data[indextr].type}}</span>
             <span v-if="data[indextr].type=='Powermeter'" class="font-weight-normal badge badge-warning badge-pill px-2 py-1">{{data[indextr].type}}</span>
             <span v-if="data[indextr].type=='Temperature'" class="font-weight-normal badge badge-success badge-pill px-2 py-1">{{data[indextr].type}}</span>
             <span v-if="data[indextr].type=='Door Sensor'" class="font-weight-normal badge badge-secondary badge-pill px-2 py-1">{{data[indextr].type}}</span>
             <span v-else class="font-weight-normal badge badge-secondary badge-pill px-2 py-1">{{data[indextr].type}}</span>
          </vs-td>
          <vs-td>
            {{data[indextr].data}}
          </vs-td>
          <vs-td>
             <div v-if="data[indextr].bat==100" class="d-flex" style="display: flex; align-items: center;">
              <a  class="text-success mr-2">
                <vs-icon icon="battery_full"></vs-icon>
              </a>
              <a class="text-success">
                {{data[indextr].bat}}%
              </a>
            </div>
             <div v-else-if="data[indextr].bat!=100&&data[indextr].bat>25" class="d-flex" style="display: flex; align-items: center;">
              <a  class="text-secondary mr-2">
                <vs-icon icon="battery_full"></vs-icon>
              </a>
              <a class="text-secondary">
                {{data[indextr].bat}}%
              </a>
            </div>
            <div v-else-if="data[indextr].bat<=25" class="d-flex" style="display: flex; align-items: center;">
              <a  class="text-danger mr-2">
                <vs-icon icon="battery_alert"></vs-icon>
              </a>
              <a class="text-danger">
                {{data[indextr].bat}}%
              </a>
            </div>
            <div v-else class="d-flex" style="display: flex; align-items: center;">
              <a  class="text-success mr-2">
                <img src="../../../../assets/electrical_services-black-36dp.svg" style="color: green"/>
              </a>
            </div>
          </vs-td>
          <vs-td>
            {{data[indextr].date}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
</div>
</template>

<script>
export default {
  name: "LastSensorState",
  data: () => ({
    temp: [],
    nwlist: [],
    sensorlist: [],
    lastsensor: []
  }),
  methods: {
  },
  created() {
    var lastdata = null
    var tempel = {}
    var temp = []
    if(this.$session.get('username') == 'sscoil') {
      // // console.log('Oil')
    }
    this.$http.get(this.$url+'sensorid/'+this.$session.get('token')).then((result) => {
      this.lastsensor = []
      // console.log(result.data)
      result.data.forEach((element) => {
        element.data = ''
        this.$http.post(this.$url+'sensornamelast',{
          name: element.name
        }).then(data => {
          lastdata = data.data[data.data.length-1]
          // console.log(lastdata)
          switch(element.type) {
            case 'control':
              Object.keys(lastdata.control).forEach((el,i) => {
                // // console.log(JSON.parse(element.lastdata)[el])
                tempel.name = element.name
                tempel.type = element.type
                tempel.data = Object.keys(lastdata.control)[i] +' = '
                if(JSON.parse(element.lastdata)[el]) tempel.data += 'On'
                else tempel.data += 'Off'
                tempel.date = this.$moment(this.$moment(lastdata.jtimestamp['time'+i]).subtract(7, 'hours')).format('YYYY-MM-DD HH:mm:ss')
                this.lastsensor.push(tempel)
                tempel = {}
              });
              break;
            case 'advantech':
              // console.log(lastdata)
              Object.keys(lastdata.calc).forEach((el,i) => {
                // // console.log(el)
                switch(el){
                  case 'ph':
                    // // console.log('case AI')
                    tempel.name = element.name
                    tempel.type = element.type
                    tempel.data = "PH: "+parseFloat(lastdata.calc[el]).toFixed(2)
                    tempel.date = this.$moment(element.date).format('YYYY-MM-DD HH:mm:ss')
                    this.lastsensor.push(tempel)
                    break;
                  case 'temp':
                    tempel.name = element.name
                    tempel.type = element.type
                    tempel.data = "Temp: "+lastdata.calc[el]
                    tempel.date = this.$moment(element.date).format('YYYY-MM-DD HH:mm:ss')
                    this.lastsensor.push(tempel)
                    break;
                  case 'totalflow':
                    tempel.name = element.name
                    tempel.type = element.type
                    tempel.data = "Total Flow: "+parseFloat(lastdata.calc[el]).toFixed(2)
                    tempel.date = this.$moment(element.date).format('YYYY-MM-DD HH:mm:ss')
                    this.lastsensor.push(tempel)
                    break;
                  // case 'reverseflow':
                  //   tempel.name = element.name
                  //   tempel.type = element.type
                  //   tempel.data = "Reverse Total Flow: "+parseFloat(lastdata.calc[el]).toFixed(2)
                  //   tempel.date = this.$moment(element.date).format('YYYY-MM-DD HH:mm:ss')
                  //   this.lastsensor.push(tempel)
                  //   break;
                  case 'flowrate':
                    tempel.name = element.name
                    tempel.type = element.type
                    if(lastdata.calc[el] != null && lastdata.calc[el] != 0 && lastdata.calc[el] != undefined )
                    tempel.data = "Flow Rate: "+parseFloat(lastdata.calc[el]).toFixed(2)
                    else tempel.data = "Flow Rate: 0"
                    tempel.date = this.$moment(element.date).format('YYYY-MM-DD HH:mm:ss')
                    this.lastsensor.push(tempel)
                    break;
                  case 'turbine':
                    tempel.name = element.name
                    tempel.type = element.type
                    if(lastdata.calc[el] != null && lastdata.calc[el] != 0 && lastdata.calc[el] != undefined )
                    tempel.data = "Turbid: "+parseFloat(lastdata.calc[el]).toFixed(2)
                    else tempel.data = "Turbid: 0"
                    tempel.date = this.$moment(element.date).format('YYYY-MM-DD HH:mm:ss')
                    this.lastsensor.push(tempel)
                    break;
                  // default:
                  //   tempel.name = element.name
                  //   tempel.type = element.type
                  //   tempel.data = el+": "+lastdata.calc[el]
                  //   tempel.date = this.$moment(lastdata.t).format('YYYY-MM-DD HH:mm:ss')
                  //   this.lastsensor.push(tempel)
                  //   break;
                }
                tempel = {}
              });
              break;
            case 'lora':
              // console.log(element.name)
              Object.keys(data.data[0]).forEach(el => {
                if(el != 'name' && el != 'type' && el != 'time') {
                  tempel.name = element.name
                  tempel.type = element.type
                  tempel.date = this.$moment(element.date).format('YYYY-MM-DD HH:mm:ss')
                  tempel.data = ''
                  if(el == 'temp') tempel.data += 'Temperature: '+data.data[0][el]+' '
                  else if(el == 'humid') tempel.data += 'Humidity: '+data.data[0][el]+' '
                  else tempel.data += el+': '+data.data[0][el]+' '
                  this.lastsensor.push(tempel)
                  tempel = {}
                }
              });
              break;
            case 'mqtt':
              // console.log(element.name)
              Object.keys(data.data[0]).forEach(el => {
                if(el != 'name' && el != 'type' && el != 'time') {
                  tempel.name = element.name
                  tempel.type = element.type
                  tempel.date = this.$moment(element.date).format('YYYY-MM-DD HH:mm:ss')
                  tempel.data = ''
                  if(el == 'temp') tempel.data += 'Temperature: '+data.data[0][el]+' '
                  else if(el == 'humid') tempel.data += 'Humidity: '+data.data[0][el]+' '
                  else tempel.data += el+': '+data.data[0][el]+' '
                  this.lastsensor.push(tempel)
                  tempel = {}
                }
              });
              break;
          }
          // console.log(this.lastsensor)
        })
      })
    })
  }
}
</script>

<style scoped>
.span {
  font-size: 14px;
}
.thead {
  padding: 0px;
}
</style>